import { render, staticRenderFns } from "./new_item.vue?vue&type=template&id=4caaad54&scoped=true"
import script from "./new_item.vue?vue&type=script&lang=js"
export * from "./new_item.vue?vue&type=script&lang=js"
import style0 from "./new_item.vue?vue&type=style&index=0&id=4caaad54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caaad54",
  null
  
)

export default component.exports